import {
  PagingSortingFilteringParams,
  SendPurchaseOrderItemMessage,
  vendorPurchaseOrderItemSchema,
  purchaseOrderItemMessagesSchema,
  vendorPurchaseOrderItemPartsSchema,
  vendorPurchaseOrderItemsPagedSchema,
  vendorsSchema,
} from "../_types";
import { get, post } from "./_gateway";

const URL = process.env.REACT_APP_API_ENDPOINT;

export async function getVendorsForAuthorizedUser() {
  const url = `${URL}/vendorPortal/vendorsForAuthorizedUser`;
  const response = await get(url);

  return vendorsSchema.parse(response.data);
}

export async function getPagedPurchaseOrderItemsByVendorId(
  vendorId: string,
  params: PagingSortingFilteringParams
) {
  const url = `${URL}/vendorPortal/pagedVendorPoItems`;
  const response = await get(url, { vendorId, ...params });

  return vendorPurchaseOrderItemsPagedSchema.parse(response.data);
}

export async function getPurchaseOrderItem(purchaseOrderItemId: number) {
  const url = `${URL}/vendorPortal/purchaseOrderitem/${purchaseOrderItemId}`;
  const response = await get(url);

  return vendorPurchaseOrderItemSchema.parse(response.data);
}

export async function getPartsForPurchaseOrderItem(
  purchaseOrderItemId: number
) {
  const url = `${URL}/vendorPortal/purchaseOrderItem/${purchaseOrderItemId}/parts`;
  const response = await get(url);

  return vendorPurchaseOrderItemPartsSchema.parse(response.data);
}

export async function updatePurchaseOrderItemPriority(
  purchaseOrderItemId: number,
  priority: number | null
) {
  const url = `${URL}/vendorPortal/purchaseOrderItem/${purchaseOrderItemId}/priority`;
  const body = { priority };
  const response = await post({ url, body });

  return response;
}

export async function getMessagesForPurchaseOrderItem(
  purchaseOrderItemId: number
) {
  const url = `${URL}/vendorPortal/purchaseOrderItem/${purchaseOrderItemId}/messages`;
  const response = await get(url);

  return purchaseOrderItemMessagesSchema.parse(response.data);
}

export async function sendPurchaseOrderItemMessage(
  purchaseOrderItemId: number,
  message: SendPurchaseOrderItemMessage
) {
  const url = `${URL}/vendorPortal/purchaseOrderItem/${purchaseOrderItemId}/messages`;
  const response = await post({ url, body: message });

  return response;
}
